import produce from 'immer';

export class StateHandlerRegistry {
  constructor() {
    this._stateHandlers = [];
  }

  register(stateHandler) {
    this._stateHandlers.push(stateHandler);
  }

  getStateHandler({ actionName, category }) {
    return this._stateHandlers.find(
      (stateHandler) =>
        stateHandler.actionName === actionName
        && stateHandler.category === category,
    );
  }

  createReducer(category) {
    const initialState = this.createInitialState(category);
    return (state = initialState, action) =>
      // Use immer to handle immutable state updates https://immerjs.github.io/immer/
      // This allows us to write code that "mutates" the state directly, but actually creates a new state
      produce(state, (draft) => {
        const stateHandler = this.getStateHandler({
          actionName: action.type,
          category,
        });

        if (!stateHandler) {
          return;
        }

        stateHandler.handleAction(draft, action);
      });
  }

  createInitialState(category) {
    return this._stateHandlers
      .filter((stateHandler) => stateHandler.category === category)
      .reduce((state, stateHandler) => {
        stateHandler.assignInitialState(state);
        return state;
      }, {});
  }
}

StateHandlerRegistry.singleton = new StateHandlerRegistry();

export const STATE_CATEGORY = {
  DATA: 'data',
  UI: 'ui',
};
